import Vue from 'vue';
import Router from 'vue-router';
import VueAnalytics from 'vue-analytics';
import StartTest from '@/components/StartTest';
import TestScreen from '@/components/TestScreen';
import ResultsScreen from '@/components/results/ResultsScreen';
import PreferredFilterPreview from '@/components/results/PreferredFilterPreview';
import UserAgreement from '@/components/UserAgreement';
import TestsHistory from '@/components/history/TestsHistory';
import HelpInfo from '@/components/help/HelpInfo';

Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'StartTest',
      component: StartTest,
    },
    {
      path: '/agreement',
      name: 'UserAgreement',
      component: UserAgreement,
    },
    {
      path: '/testScreen',
      name: 'TestScreen',
      component: TestScreen,
    },
    {
      path: '/result/:testId',
      name: 'ResultsScreen',
      component: ResultsScreen,
    },
    {
      path: '/result/:testId/preview/:color',
      name: 'PreferredFilterPreview',
      component: PreferredFilterPreview,
    },
    {
      path: '/history',
      name: 'TestsHistory',
      component: TestsHistory,
    },
    {
      path: '/help',
      name: 'HelpInfo',
      component: HelpInfo,
    },
  ],
});

Vue.use(VueAnalytics, {
  id: 'UA-128458158-1',
  router,
});

export default router;
